<script lang="ts">
	import type { TableData } from '@repo/commons/models'
	import { Label } from '@repo/commons/components'

	type Props = {
		row: TableData
	}

	const { row }: Props = $props()

	const possibleValues: string[] = $derived(row.possibleValues ?? [])
</script>

<div class="possible-values-cell">
	{#each possibleValues as value, index (index)}
		<Label label={value} variant="default" />
	{/each}
</div>

<style lang="postcss">
	.possible-values-cell {
		@apply flex flex-wrap gap-2;
	}
</style>
